module.exports = __webpack_public_path__ + "img/box_xl.7e66b59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/box_xl.svg
// module id = luKH
// module chunks = 1